// Arquivo gerado automaticamente por generate-version-manifest.js
// NUNCA EDITE MANUALMENTE

export interface VersionManifest {
  version: string;
  buildId: string;
  gitCommit: string;
  gitBranch: string;
  buildTimestamp: string;
  environment: string;
}

export const LOCAL_BUILD_METADATA: VersionManifest = {
  "version": "v5.82.4",
  "buildId": "1790692446817",
  "gitCommit": "563dec834",
  "gitBranch": "main",
  "buildTimestamp": "2026-09-29T14:34:06.980Z",
  "environment": "production"
};
